import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import HomeBanner from '../components/home/HomeBanner'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Link } from 'react-router-dom'
import Img1 from '../assets/images/800home/Img1.webp'
import Icon1 from '../assets/images/Icons/1.png'
import Icon2 from '../assets/images/Icons/2.png'
import Icon3 from '../assets/images/Icons/3.png'
import Icon4 from '../assets/images/Icons/4.png'
import Icon5 from '../assets/images/Icons/5.png'
import Icon6 from '../assets/images/Icons/6.png'
import Icon7 from '../assets/images/Icons/7.png'
import Icon8 from '../assets/images/Icons/8.png'
import Icon9 from '../assets/images/Icons/9.png'
import Icon10 from '../assets/images/Icons/10.png'
import Icon11 from '../assets/images/Icons/11.png'
import Icon12 from '../assets/images/Icons/12.png'
import Icon13 from '../assets/images/Icons/13.png'
import Icon14 from '../assets/images/Icons/14.png'
import Icon15 from '../assets/images/Icons/15.png'
import Icon16 from '../assets/images/Icons/16.png'
import Icon17 from '../assets/images/Icons/17.png'
import Icon18 from '../assets/images/Icons/18.png'
import Icon19 from '../assets/images/Icons/19.png'
import Icon20 from '../assets/images/Icons/20.png'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'
import BannerImg from '../assets/images/800home/HomeBanner.webp'
import BgMiddle from '../assets/images/800home/Img2.webp'
import HomeSliderListing from '../components/listing/HomeSliderListing'
import axios from 'axios'
import AwardsAndAchievementsSection from '../components/AwardsAndAchievementsSection'

const Home = () => {
  const [counterOn, setCounterOn] = useState(false)
  const [transactionData, setTransactionData] = useState({})

  useEffect(() => {
    fetchTransactionData()
  }, [])

  const fetchTransactionData = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/transaction`)
      setTransactionData(data?.result || {})
    } catch (error) {
      console.error('transaction data', error)
      setTransactionData({})
    }
  }

  // Helpers
  const num = (v) => {
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
  }
  const countDecimals = (v) => {
    const n = Number(v)
    if (!Number.isFinite(n)) return 0
    const s = String(n)
    const i = s.indexOf('.')
    return i >= 0 ? s.length - i - 1 : 0
  }

  const transactionVal = num(transactionData?.transaction)
  const propertySaleVal = num(transactionData?.property_sale)
  const unitSoldVal = num(transactionData?.unit_sold)

  const tDecimals = countDecimals(transactionData?.transaction)
  const pDecimals = countDecimals(transactionData?.property_sale)
  const uDecimals = countDecimals(transactionData?.unit_sold)

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Real Estate Agency Dubai | Find Your Ideal Property | 800 Homes </title>
        <meta
          name="description"
          content="Looking to buy or sell in Dubai? Our real estate agency and expert real estate broker team delivers top deals, verified listings, and full support. Call Now !"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Real Estate Agency Dubai | Find Your Ideal Property | 800 Homes" />
        <meta
          property="og:description"
          content="Looking to buy or sell in Dubai? Our real estate agency and expert real estate broker team delivers top deals, verified listings, and full support. Call Now !"
        />
        <meta property="og:url" content="https://800homes.ae/" />
        <meta property="og:site_name" content="800homes" />
        <meta property="og:image" content="https://800homes.ae/og.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content="Looking to buy or sell in Dubai? Our real estate agency and expert real estate broker team delivers top deals, verified listings, and full support. Call Now !"
        />
        <meta name="twitter:title" content="Real Estate Agency Dubai | Find Your Ideal Property | 800 Homes" />
        <meta name="twitter:image" content="https://800homes.ae/og.webp" />
        <link rel="canonical" href="https://800homes.ae" />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "800 Homes",
            "alternateName": "800 Homes Real Estate Brokerage",
            "url": "https://800homes.ae/",
            "logo": "https://800homes.ae/og.webp",
            "image": "https://800homes.ae/og.webp",
            "description": "800 Homes is a trusted real estate brokerage in Dubai offering property buying, selling, and renting services across UAE.",
            "telephone": "+971-58-574-6637",
            "email": "inquiry@800homes.ae",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "First Floor, Deyaar Head Office Building - Office 111 - Al Barsha First - Al Barsha - Dubai - United Arab Emirates",
              "addressLocality": "Dubai",
              "addressRegion": "Dubai",
              "postalCode": "392524",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "25.117219021497814",
              "longitude": "55.19671355262039"
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
                "opens": "10:00",
                "closes": "18:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "10:00",
                "closes": "14:00"
              }
            ],
            "priceRange": "AED",
            "areaServed": {
              "@type": "City",
              "name": "Dubai"
            },
            "sameAs": [
              "https://www.facebook.com/800homes",
              "https://www.instagram.com/800homesae",
              "https://www.linkedin.com/company/800-homes-real-estate-brokerage-firm/",
              "https://www.youtube.com/@800HomesRE",
              "https://www.tiktok.com/@800homes"
            ],
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "bestRating": "5",
              "ratingCount": "120",
              "reviewCount": "95"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Dubai Real Estate Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Property Buying Consultation"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Property Selling Services"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Property Rental Services"
                  }
                }
              ]
            }
          }`}
        </script>
      </Helmet>

      <section id="website-responsive" className="container-fluid px-0">
        <section
          className="container-fluid bg-home-banner bg-home vh-100 px-0"
          style={{ backgroundImage: `url(${BannerImg})` }}
        >
          <Header />
          <HomeBanner />
        </section>

        <section className="py-md-5 py-4" />

        <section className="container-fluid">
          <div className="row justify-content-evenly gy-4">
            <div className="col-11 col-md-6">
              <div className="col-md-8 ps-lg-2 mx-auto">
                <div className="pb-2 pb-md-4 text-ss-primary fs-ss-18 fw-400">
                  Invest in Dubai Real Estate
                </div>
                <h2 className="pb-md-3 text-white fs-ss-40 fw-500 lh-sm">
                  Why Choose 800 Homes as Your Property Partner? 
                </h2>
              </div>
            </div>
            <div className="col-11 col-md-6 col-lg-5">
              <div
                className="pb-4 text-white fs-ss-16 fw-300 col-md-10 pe-lg-5 lh-1-7em"

              >
                Great real estate results start with the right partner. 800 Homes offers end-to-end services from buying to after-sales support with full transparency. Receive personalized guidance, practical advice, and efficient solutions every step of the way. Connect with our experts and achieve your property goals today.
              </div>
              <div className="pb-md-3 text-white fs-ss-18 fw-400">
                <Link
                  to="/contact-us"
                  className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                >
                  Contact for Details
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-md-5 py-4" />
        <section className="pt-4 pt-md-0" />

        <section className="container-fluid">
          <div className="row justify-content-center justify-content-lg-end text-md-center text-lg-start gy-4">
            <div className="col-11 col-md-8 col-lg-5 align-self-center">
              <div className="col-12 col-lg-10 mx-auto">
                <div className="text-uppercase fw-500 pb-2 pb-md-4">
                  <h2 className="fs-ss-30 text-white text-shadow-parent pb-4">
                    Our Real Estate Services
                  </h2>
                </div>

                <div className="pb-md-4 text-white fs-ss-18 fw-300 col-lg-10">
                  <div className="pb-4">
                    <h3 className="text-ss-primary fs-ss-22 fw-600">Buying Properties</h3>
                    <div className="lh-1-7em">
                      We ease the property buying process by offering expert guidance every step
                      of the way.
                    </div>
                  </div>

                  <div className="pb-4">
                    <h3 className="text-ss-primary fs-ss-22 fw-600">Selling Properties</h3>
                    <div className="lh-1-7em">
                      We make the selling process efficient and effective to achieve possible
                      sales and maximize your property’s value.
                    </div>
                  </div>

                  <div className="pb-4">
                    <h3 className="text-ss-primary fs-ss-22 fw-600">Investment Advisory</h3>
                    <div className="lh-1-7em">
                      Our advisory services provide clear, practical advice to help you make smart
                      investment choices.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-11 col-md-8 col-lg-6 px-0">
              <img
                src={Img1}
                className="w-100"

                alt="Dubai real estate services showcase"
              />
            </div>
          </div>
        </section>

        <section className="py-md-5 py-4" />
        <section className="pt-4 pt-md-0" />

        <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          <section id="numbers" className="container-lg">
            <div className="row justify-content-center text-center px-md-5 gy-4">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">
                Dubai Real Estate Transactions
              </h2>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={transactionVal} decimals={tDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.transaction_unit ? ` ${transactionData.transaction_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Total Transactions in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={propertySaleVal} decimals={pDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.property_sale_unit ? ` ${transactionData.property_sale_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Property Sales in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>

              <div className="col-md">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={unitSoldVal} decimals={uDecimals} duration={4} delay={0} />
                  )}
                  {transactionData?.unit_sold_unit ? ` ${transactionData.unit_sold_unit}` : ''}
                </div>
                <div className="fs-ss-18 text-white">
                  {`Units Sold in ${transactionData?.transaction_month || ''}, ${new Date().getFullYear()}`}
                </div>
              </div>
            </div>
          </section>
        </ScrollTrigger>

        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          <section id="numbers" className="container-lg">
            <div className="row justify-content-center text-center px-md-5 gy-4">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-500">
                Dubai Real Estate Transactions
              </h2>

              <div className="col-md border-white border-end border-1">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={215346} decimals={0} duration={4} delay={0} />
                  )}
               
                </div>
                <div className="fs-ss-18 text-white">
                  Total Transactions in 2025
                </div>
              </div>

              <div className="col-md">
                <div className="fs-ss-40 text-ss-primary fw-600">
                  {counterOn && (
                    <CountUp start={0} end={686.8} decimals={pDecimals} duration={4} delay={0} />
                  )}
                  B
                </div>
                <div className="fs-ss-18 text-white">
                  Property Sales in 2025
                </div>
              </div>
            </div>
          </section>
        </ScrollTrigger> */}
        <section className="py-md-5 py-4" />
        <section
          id="bg-middle-banner"
          className="container-fluid bg-middle-banner py-5"
          style={{ backgroundImage: `url(${BgMiddle})` }}
        >
          <div className="row justify-content-evenly gy-4 py-md-5">
            <div className="col-11 col-md-9 mx-auto">
              <h2 className="pb-2 pb-md-4 text-white fs-ss-35 fw-600 col-lg-7">
                Explore Villas, Apartments & Off-Plan Properties
              </h2>
              <div
                className="pb-3 pb-md-4 text-white fs-ss-22 fw-300 col-lg-7 lh-1-7em"

              >
                Dreaming of your perfect Dubai home? Explore our collection of elegant villas, modern apartments, and exclusive off-plan properties. Each offers premium design and exceptional comfort. Find your ideal property today.
              </div>
              <div className="text-white fs-ss-18 fw-400">
                <Link
                  to="/contact-us"
                  className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                >
                  Inquire Now
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-md-5 py-4" />

        <AwardsAndAchievementsSection />

                               <section className="py-md-5 py-4" />
 
        <section className="container-fluid">
          <div className="text-center">
            <div className="text-ss-primary fs-ss-18 fw-400">Trusted Developers</div>
            <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">
              Partners in Property Excellence
            </h2>
          </div>
          <div
            className="row justify-content-evenly align-items-center gy-0 px-4 px-md-5 mx-md-5"

          >
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon1} className="w-100" alt="Developer Partner Logo 1" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon2} className="w-100" alt="Developer Partner Logo 2" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon3} className="w-100" alt="Developer Partner Logo 3" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon4} className="w-100" alt="Developer Partner Logo 4" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon5} className="w-100" alt="Developer Partner Logo 5" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon6} className="w-100" alt="Developer Partner Logo 6" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon7} className="w-100" alt="Developer Partner Logo 7" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon8} className="w-100" alt="Developer Partner Logo 8" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon9} className="w-100" alt="Developer Partner Logo 9" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon10} className="w-100" alt="Developer Partner Logo 10" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon11} className="w-100" alt="Developer Partner Logo 11" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon12} className="w-100" alt="Developer Partner Logo 12" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon13} className="w-100" alt="Developer Partner Logo 13" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon14} className="w-100" alt="Developer Partner Logo 14" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon15} className="w-100" alt="Developer Partner Logo 15" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon16} className="w-100" alt="Developer Partner Logo 16" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon17} className="w-100" alt="Developer Partner Logo 17" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon18} className="w-100" alt="Developer Partner Logo 18" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon19} className="w-100" alt="Developer Partner Logo 19" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons"><img src={Icon20} className="w-100" alt="Developer Partner Logo 20" /></div>
            <div className="col-3 col-md-2 mx-md-1 px-md-5 hover-icons d-block d-md-none" />
          </div>
        </section>

        <section className="py-md-5 py-4 my-md-2" />
        <section className="pt-md-0" />

        <section className="container-lg">
          <div className="text-center">
            <div className="text-ss-primary fs-ss-18 fw-400">800 Homes</div>
            <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">Explore Properties</h2>
          </div>
          <div id="testimonials" className="">
            <HomeSliderListing />
            <div className="pt-5 text-white fs-ss-18 fw-400 text-center">
              <Link
                to="/properties-for-sale"
                className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
              >
                View All
              </Link>
            </div>
          </div>
        </section>

        <section className="py-md-5 py-4" />
        <section className="pt-4 pt-md-0" />
        <Footer />
      </section>
    </>
  )
}

export default Home
